import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { postStream } from '../../../api/streams';

import { mergeStreamWithUserData } from '../../../utils/streams';
import { generateStreamCIDKey } from '../../../components/Streams/utils/generateStreamCIDKey';
import { REQUEST } from '../../../constants/request';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const createStream = createAsyncThunk(
  `streams/createStream`,
  async (streamData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [streamResponse, streamUserDataResponse] = await postStream(
        streamData,
        {
          cancelToken: source.token,
        },
      );
      return mergeStreamWithUserData(streamResponse, streamUserDataResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition({ path: { orgId }, body: { id } }, { getState }) {
      const streamCIDKey = generateStreamCIDKey({ orgId, id });
      const { streams } = getState().streams;

      return (
        streams.stream.allIds.includes(streamCIDKey) ||
        streams.stream.actions.create.request[streamCIDKey]?.loading !==
          REQUEST.pending
      );
    },
  },
);

export const createStreamExtraReducers = builder => {
  builder
    .addCase(createStream.pending, (state, action) => {
      const streamCIDKey = generateStreamCIDKey(action.meta.arg.path);

      checkAndSetLoadingWithId(
        state.streams.stream.actions.create.request,
        action,
        streamCIDKey,
      );
    })
    .addCase(createStream.fulfilled, (state, action) => {
      const streamCIDKey = generateStreamCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.streams.stream.actions.create.request[streamCIDKey],
        action,
        () => {
          state.streams.stream.byId[streamCIDKey] = { ...action.payload };
          state.streams.stream.allIds.push(streamCIDKey);
        },
      );
    })
    .addCase(createStream.rejected, (state, action) => {
      handleRequestRejection(
        state.streams.stream.actions.create.request[
          generateStreamCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
